import VTable from "@/components/table/index.vue";
import { mapGetters, mapActions } from "vuex";
import VLayout from "@/layouts/Default.vue";
import VPageHeader from "@/components/pageheader/PageHeader.vue";
import VLoader from "@/components/loader/index.vue";
// import EventBus from '@/plugins/event-bus';

export default {
    name: "Groups",
    components: {
        VTable,
        VLayout,
        VPageHeader,
        VLoader
    },
    data() {
        return {
            roles: {
                CARE_AUTHOR: "Author",
                CARE_NAVIGATOR: "Navigator"
            },
            isAdding: false,
            addGroupModel: {
                name: '',
                description: '',
            }
        };
    },
    computed: {
        ...mapGetters({
            groups: "group/getAllGroups",
            isLoading: "group/getLoading",
            getGroupByIdFromState: "group/getGroupByIdFromState",
            permissions: "auth/getModulePermissions",
        }),
        enableActions() {
            return this.permissions.group.edit;
        }
    },
    watch: {
        filter: {
            handler: "fetchGroups",
            immediate: true
        }
    },
    methods: {
        ...mapActions(
            'group', {
            editStart: 'editStart',
            editCancel: 'editCancel',
            saveGroup: 'saveGroup',
            upsertGroup: 'upsert',
        }
        ),
        fetchGroups() {
            this.$store.dispatch("group/viewAll", this.filter);
        },
        _editGroup(group) {
            var g = this.getGroupByIdFromState(group.id)
            // eslint-disable-next-line 
            console.log('_editGroup g, group', g, group);

            this.editStart(group.id);
        },
        _deleteGroup(group) {
            // eslint-disable-next-line 
            console.log('_deleteGroup', group);
        },
        _cancelEditGroup(group) {
            // eslint-disable-next-line 
            console.log('_cancelEditGroup', group);

            this.editCancel(group.id);
        },
        _saveGroup(group) {
            // eslint-disable-next-line 
            console.log('_saveGroup', group.shadowCopy);

            this.saveGroup(group.shadowCopy);
        },
        _addGroupStart() {
            // eslint-disable-next-line 
            console.log('_addGroup');

            this.isAdding = true;
            this.addGroupModel = {
                name: '',
                description: '',
            }
        },
        _addGroup() {
            // eslint-disable-next-line 
            console.log('_addGroup');

            this.upsertGroup(this.addGroupModel);

            this.isAdding = false;
        },
        _cancelAddGroup() {
            // eslint-disable-next-line 
            console.log('_cancelAddGroup');

            this.isAdding = false;
        },
        _AssignGroup(group) {
            // eslint-disable-next-line 
            console.log('_AssignGroup');            
            this.$router.push({
                name: 'group.assign', params: { id: group.id, group }
              });
        },        
    },
};